import style from './style';
import {
	TOOLTIP_LABEL,
	SDG_OTHERS
} from '../../constants';

const getItemPercentage = (data, code) => {
	const total = data.map((row) => row.children.reduce((total, item) => (total + item.size.budget), 0)).reduce((total, item) => (total + item), 0)
	const element = data.find((item) => item.code === code).children.reduce((total, item) => (total + item.size.budget), 0)
	return (100 * element / total).toFixed(1);
}

const getData = (data, side) => (
	side === "right" ?
		data.slice(0, Math.ceil(data.length / 2)) :
		data.slice(Math.ceil(data.length / 2), data.length)
)

const getItemLink = (item) => {
	const cleaned = item.name.replace("Target ", "");
	const firstPart = cleaned.substring(0, cleaned.indexOf("."))
	const secondPart = cleaned.substring(cleaned.indexOf(".") + 1)
	return `/programme-area/targets/${firstPart}/${secondPart}`
}

const SDGLegend = (props) => {
	return (
		<div class={style.sdgLegend}>
			{props.data &&
				getData(props.data, props.side).map((itemMain) => (
					<div>
						<div style={{ marginTop: '20px' }} class={`${props.side === "right"?style.sdgItem:style.sdgItemRight} ${props.sdgTooltip === TOOLTIP_LABEL ? style.rightSDG : style.leftSDG}`}>
							<span style={itemMain.code !== SDG_OTHERS ?
								{ backgroundColor: '#' + itemMain.color }
								: null} class={style.sdgImageTop}
							>
								<img class={itemMain.code !== SDG_OTHERS ? style.imageItem : style.othersItem}
									src={props.baseURL + `${itemMain.image}`}
								/>
							</span>
							<div class={style.sdgName}>
								<a
									href={`/programme-area/${itemMain.code}/${itemMain.fullName}`}
									target={props.embed ? '_blank' : '_self'}
								>
									<span class={style.sdgName}>{itemMain.fullName}</span>
								</a>
							</div>
							{
								props.side === "right" ?
									(
										<div className={style.mainPercentageWrapper}>
											<div style={{ backgroundColor: `#${itemMain.color}` }} />
											<span>{getItemPercentage(props.data, itemMain.code)}%</span>
										</div>
									) :
									(
										<div className={style.mainPercentageWrapper}>
											<span>{getItemPercentage(props.data, itemMain.code)}%</span>
											<div style={{ backgroundColor: `#${itemMain.color}` }} />
										</div>
									)
							}
						</div>
						{itemMain.children.map((item, index) => (

							<div class={`${style.sdgItem} ${props.sdgTooltip === TOOLTIP_LABEL ? style.rightSDG : style.leftSDG}`} key={index} >
								<span style={{ 'width': '10%', 'marginRight': '20px' }}>{Number(item.size.percentage).toFixed(1)}%</span>
								<span class={style.sdgImage}
									style={item.code !== SDG_OTHERS ?
										{ backgroundColor: '#' + itemMain.color }
										: null}
								>
								</span>
								{item.code === SDG_OTHERS ?
									<span id={`${props.sdgTooltip}-${index}`} class={style.sdgName}> {item.name} </span> :
									<a
										style={{ 'padding': '0 10px' }} id={`${props.sdgTooltip}-${index}`}
										href={getItemLink(item)}
										target={props.embed ? '_blank' : '_self'}
									>
										<span class={style.sdgName}>{item.name}</span>
									</a>
								}
							</div>
						))
						}
					</div>
				))

			}
			<div id={props.sdgTooltip} class={style.sdgTooltip} />
		</div>
	);
}
	;

export default SDGLegend;


// WEBPACK FOOTER //
// ./components/paSunburstChart/components/sdgLegend/index.js